import { useEffect, type FunctionComponent, } from "react";
import { ChooseChainEL, } from "./ChooseChainEL";
import { AccountEL, } from "./AccountEL";
import { Button, } from "@bracket/react-button";

import "./ConnectionManager.scss";




export const ConnectionHUD = () => {
	const classes = () => [ `hud` ].join(" ");

	return (
		<div className={classes()}>
				 <>
					<ChooseChainEL />
					<AccountEL />
				</>
		</div>
	);

}